// extracted by mini-css-extract-plugin
export default {"emptyList":"y-F3c","widget":"edNmX","title":"Us3kx","skeleton-progress":"yBhU7"};